import React from 'react'
import { cn } from '~/lib/utils'
import YnsIcon from '../../icons/YnsIcon'

const Tabs = ({
  items,
  selectedItem,
  onSelect,
  className,
  variant = 'primary',
}) => {
  const activeBarColor =
    variant === 'primary' ? 'bg-intoo-blue-medium' : 'bg-intoo-green-medium-700'

  return (
    <div className={cn('border-b border-cod-gray-200', className)}>
      <ul className="mb-px flex gap-10 overflow-x-auto">
        {items.map((item) => {
          const isSelected = selectedItem === item.key
          return (
            <li key={item.key} className="me-2">
              <button
                onClick={() => onSelect?.(item.key)}
                className={cn(
                  'relative flex min-w-16 flex-col items-center',
                  'text-cod-gray-800 hover:text-gray-600',
                )}
              >
                {item.icon && (
                  <YnsIcon name={item.icon} size={24} aria-hidden="true" />
                )}
                <span
                  className={cn(
                    'mx-0 my-2 whitespace-nowrap text-center text-sm',
                    isSelected ? 'font-medium' : 'font-normal',
                  )}
                >
                  {item.label}
                </span>
                <div
                  className={cn(
                    'h-1 w-full rounded-t-sm',
                    isSelected ? activeBarColor : 'bg-transparent',
                  )}
                ></div>
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Tabs
